import { PROPERTIES_SELECTION } from 'components/forms/domain/property/PropertyMultiSelectFilterField/PropertyMultiSelectFilterField.constants';
import * as Yup from 'yup';
import { APPLIES_TO_FIELD_NAME } from './DeleteSeasonalRuleModal.constants';

export const deleteSeasonalRuleFormSchema = () =>
  Yup.object({
    appliesTo: Yup.string().required(),
    appliesToProperties: Yup.array()
      .of(
        Yup.object({
          isFixed: Yup.boolean().optional(),
          label: Yup.string(),
          value: Yup.string(),
        }),
      )
      .label('properties')
      .when(APPLIES_TO_FIELD_NAME, {
        is: PROPERTIES_SELECTION.ALL_PROPERTIES,
        then: (schema) => schema.optional().nullable(true),
        otherwise: (schema) => schema.min(1).required(),
      }),
  });

export type DeleteSeasonalRuleFormValues = Yup.InferType<
  ReturnType<typeof deleteSeasonalRuleFormSchema>
>;
